import { render, staticRenderFns } from "./statistic_platform_user.vue?vue&type=template&id=15da99fa&scoped=true"
import script from "./statistic_platform_user.vue?vue&type=script&lang=js"
export * from "./statistic_platform_user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da99fa",
  null
  
)

export default component.exports